import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=1c20def3&scoped=true"
import script from "./GroupCard.vue?vue&type=script&lang=js"
export * from "./GroupCard.vue?vue&type=script&lang=js"
import style0 from "./GroupCard.vue?vue&type=style&index=0&id=1c20def3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20def3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c20def3')) {
      api.createRecord('1c20def3', component.options)
    } else {
      api.reload('1c20def3', component.options)
    }
    module.hot.accept("./GroupCard.vue?vue&type=template&id=1c20def3&scoped=true", function () {
      api.rerender('1c20def3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/screens/GroupCard.vue"
export default component.exports